/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Description_PlaceholderInputs */

const cs_workflow_description_placeholder = /** @type {(inputs: Workflow_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volitelné poznámky pro tým`)
};

const en_workflow_description_placeholder = /** @type {(inputs: Workflow_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional notes for your team`)
};

/**
* | output |
* | --- |
* | "Optional notes for your team" |
*
* @param {Workflow_Description_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_description_placeholder = /** @type {((inputs?: Workflow_Description_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Description_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_description_placeholder(inputs)
	return cs_workflow_description_placeholder(inputs)
});